import type { MenuItem } from '@/types';

/**
 * iOS docs menu
 */
export const iosDocs: MenuItem[] = [
  { label: 'Overview', path: '/sdk_ref/ios/overview' },
  {
    label: 'Express API',
    path: '/sdk_ref/ios/express',
    openNested: true,
    submenu: [
      { label: 'Channel', path: '/sdk_ref/ios/express-channel' },
      { label: 'Room', path: '/sdk_ref/ios/express-room' },
      { label: 'PCast™', path: '/sdk_ref/ios/express-pcast' },
    ],
  },
  {
    label: 'Low-Level API',
    path: '/sdk_ref/ios/low-level',
    openNested: true,
    submenu: [
      { label: 'Room', path: '/sdk_ref/ios/room' },
      { label: 'Chat', path: '/sdk_ref/ios/chat' },
      { label: 'PCast™', path: '/sdk_ref/ios/pcast' },
    ],
  },

  { label: 'Examples', path: '/sdk_ref/ios/examples' },
  { label: 'Release Notes', path: '/sdk_ref/ios/release-notes' },
];
